module.exports = __webpack_public_path__ + "NH_features_readable.e38fc82c.svg";